<template>
  <div>
    <a-layout>
      <drawer v-if="isMobile" :openDrawer="collapsed" @change="onDrawerChange">
        <sider-menu
          :theme="theme"
          :menuData="menuData"
          :collapsed="false"
          :collapsible="false"
          @menuSelect="onMenuSelect"
        />
      </drawer>
      <sider-menu
        class="g-side"
        :theme="theme"
        v-else-if="layout === 'side'"
        :menuData="menuData"
        :collapsed="collapsed"
        :collapsible="true"
      />
      <a-layout :class="['g-main',{'pd80' : collapsed}]">
        <global-header
          :menuData="menuData"
          :collapsed="collapsed"
          @toggleCollapse="toggleCollapse"
        />
        <a-layout-content :style="{minHeight: minHeight, margin: '24px 24px 0'}">
          <slot></slot>
        </a-layout-content>
        <a-layout-footer style="padding: 0px">
          <global-footer :copyright="copyright" />
        </a-layout-footer>
      </a-layout>
    </a-layout>
    <a-modal title="提示" :visible="visible" @cancel="handleCancel" @ok="handleOk" okText="前往填写">
      <p>{{tipText}}</p>
    </a-modal>
  </div>
</template>

<script>
import GlobalHeader from "./GlobalHeader";
import GlobalFooter from "./GlobalFooter";
import Drawer from "../components/tool/Drawer";
import SiderMenu from "../components/menu/SiderMenu";
import Setting from "../components/setting/Setting";
import { getLoginUser, getMenuData } from "@/libs/global";
import menuConfig from "@/router/menuConfig";

import menu from "../components/menu/menu";

// 屏幕高度-导航高度-容器上边距(margin-top)-页面版权高度
const minHeight = window.innerHeight - 64 - 24 - 70;

export default {
    name: "GlobalLayout",
    components: { Setting, SiderMenu, Drawer, GlobalFooter, GlobalHeader },
    data() {
        return {
            minHeight: minHeight + "px",
            collapsed: false,
            menuData: [],
            visible: false,
            tipText: ""
        };
    },
    computed: {
        isMobile() {
            return this.$store.state.setting.isMobile;
        },
        theme() {
            return this.$store.state.setting.theme;
        },
        layout() {
            return this.$store.state.setting.layout;
        },
        copyright() {
            return this.$store.state.setting.copyright;
        }
    },
    mounted() {
        // 根据权限显示菜单
         this.getMenuFromServer();

        // 测试用，越过权限，显示全部菜单
        //this.showAllMenus();

    },
    methods: {
        toggleCollapse() {
            this.collapsed = !this.collapsed;
        },
        onDrawerChange(show) {
            this.collapsed = show;
        },
        onMenuSelect() {
            this.toggleCollapse();
        },
        showAllMenus() {
            let rawMenuData = this.$router.options.routes
                .find(item => item.path === "/")
                .children.filter(item => item.path !== "/home");
            let menu = [];
            for (let key in menuConfig) {
                let matchedMenus = rawMenuData.filter(
                    item => item.path.indexOf(key) === 0
                );
                menu.push({
                    path: key,
                    ...menuConfig[key],
                    children: matchedMenus
                });
            }
            this.menuData = menu;
        },
        //获取用户菜单
        getMenuFromServer() {
            getLoginUser().then(user => {
                this.$store.commit("account/setuser", user);

                // 未配置商户号店铺全局弹窗
                if (user.userType === "R05") {
                    this.$axios.post(this.$apis.OVERALL_SHOPNUM).then(res => {
                        if (res.success) {
                            if (
                                res.data.shopNum == "" ||
                                res.data.businessStoreNum == ""
                            ) {
                                this.tipText =
                                    "检测到店铺未填写支付商户号，这会影响用户支付，请尽快填写！";
                                this.visible = true;
                            }
                        }
                    });
                }
                getMenuData()
                    .then(menuData => {
                        this.menuData = menuData;
                    })
                    .catch(e => {
                        this.$message.error(e.message);
                    });
            });

            
        },

        handleOk() {
            this.visible = false;
            this.$router.push("/system/shopMgr/shopNumConfig");
        },
        handleCancel() {
            this.visible = false;
        }
    }
};
</script>

<style lang="less" scoped>
.setting {
    background-color: #1890ff;
    color: #fff;
    border-radius: 5px 0 0 5px;
    line-height: 40px;
    font-size: 22px;
    width: 40px;
    height: 40px;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
}
.g-side {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
}
.g-main {
    margin-left: 256px;
    &.pd80 {
        margin-left: 80px;
    }
}
</style>



// WEBPACK FOOTER //
// src/layouts/GlobalLayout.vue